import React from "react";
import { useTranslation } from "react-i18next";
import { events } from "@planzone/events";

import { useMessage } from "@components/useMessage";
import { useAuthentication, useChangePassword } from "@planzone/view-models";
import { Button } from "@common/button";
import { Props } from "./types";
import { Input } from "./input";
import { Error } from "./error";
import styles from "./styles.scss";

function ChangePassword(props: Props) {
  const { t } = useTranslation();
  const { account } = useAuthentication();
  const { isRequestPending, error, changePassword } = useChangePassword();
  const [formData, setFormData] = React.useState({
    currentPassword: "",
    password: "",
    passwordConfirmation: "",
  });

  useMessage(
    ({ type }) =>
      type === events.changePasswordSucceeded &&
      setFormData({
        currentPassword: "",
        password: "",
        passwordConfirmation: "",
      }),
  );

  return (
    <form
      className={styles.changePassword}
      onSubmit={(e) => {
        e.preventDefault();

        !isRequestPending &&
          changePassword({
            account,
            currentPassword: formData.currentPassword,
            nextPassword: formData.password,
            passwordConfirmation: formData.passwordConfirmation,
          });
      }}
    >
      <div className={styles.group}>
        <Input
          value={formData.currentPassword}
          isInvalid={error.wrongPassword}
          placeholder={t("preferences.changePassword.currentPassword")}
          input={(currentPassword) =>
            setFormData({ ...formData, currentPassword })
          }
        />
      </div>
      <div className={styles.group}>
        <Input
          value={formData.password}
          isInvalid={
            error.isTooShort ||
            error.doesNotHaveUpper ||
            error.doesNotHaveNumberOrSpecialChar
          }
          placeholder={t("preferences.changePassword.placeholder")}
          input={(password) => setFormData({ ...formData, password })}
        />
      </div>
      <div className={styles.group}>
        <Input
          value={formData.passwordConfirmation}
          isInvalid={error.mismatchedConfirmation}
          placeholder={"******"}
          input={(passwordConfirmation) =>
            setFormData({ ...formData, passwordConfirmation })
          }
        />
      </div>
      <div className={styles.error}>
        <Error error={error} />
      </div>
      <div className={styles.footer}>
        <Button status={isRequestPending ? "pending" : "none"} type="submit">
          {t("preferences.changePassword.submit")}
        </Button>
      </div>
    </form>
  );
}

export { ChangePassword };
